import React, { useEffect, useRef, useState } from 'react';
import { Row, Col, Table, Pagination } from 'react-bootstrap';
import styles from './admin-listing-list.module.scss';
import detailsArrowIcon from "../../../../assets/table-details-arrow.svg";
import paginationLeftIcon from "../../../../assets/pagination-arrow-left.svg";
import paginationRightIcon from "../../../../assets/pagination-arrow-right.svg";
import usePagination from "../../../../hooks/use-pagination";
import ListingService from "../../../../services/listing-service";
import { useHistory } from "react-router-dom";
import Loading from "../../../../components/loading/loading";
import { toCurrency } from "../../../../helpr/helper";
import {
  TERM_SHEET_CONFIRMED,
  TERM_SHEET_DRAFT,
  TERM_SHEET_REJECTED,
  TERM_SHEET_SUBMITTED
} from "../../../../helpr/constants";

const AdminListingList = () => {
  const [loading, setLoading] = useState(true);

  const tableHeaders = [
    {value: 'Created By', class: ''},
    {value: 'Name of Security', class: ''},
    {value: 'Issue / Reopening Amount', class: 'align-right'},
    {value: 'Maturity Date', class: ''},
    {value: 'Listing Date', class: ''},
    {value: 'Last Update', class: ''},
    {value: 'Status', class: ''}
  ]
  const [termSheetList, setTermSheetList] = useState([]);
  const history = useHistory();

  // Ref to track if the component is still mounted
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    // Create the service instance inside the effect (1 instance per mount)
    const service = new ListingService();

    const retrieveTermSheets = async () => {
      try {
        const result = await service.retrieveTermSheets();
        if (!isMountedRef.current) return;
        setTermSheetList(result);
      } catch (error) {
        console.error(error);
        // Redirect, but don't set state after this
        if (isMountedRef.current) {
          history.push(`/internal-server-error`);
        }
      } finally {
        if (isMountedRef.current) {
          setLoading(false);
        }
      }
    };

    retrieveTermSheets();

    return () => {
      isMountedRef.current = false;
    };
  }, [history]);

  const pagedData = usePagination(termSheetList, 10);
  const pages = Array(pagedData.maxPage).fill().map((_, i) =>
    <Pagination.Item
      key={i + 1}
      active={(i + 1) === pagedData.currentPage}
      onClick={() => pagedData.jump(i + 1)}>
      {i + 1}
    </Pagination.Item>
  );

  const renderStatus = (status) => {
    switch (status) {
      case TERM_SHEET_DRAFT:
        return 'Draft - Pending Submission';
      case TERM_SHEET_SUBMITTED:
        return 'Submitted';
      case TERM_SHEET_CONFIRMED:
        return 'Confirmed';
      case TERM_SHEET_REJECTED:
        return 'Rejected';
      default:
        return '';
    }
  };

  return (
    <div className={`${styles['admin-term-sheet-list']} ${styles['panel']}`}>
      <Row>
        <Col>
          <div className={styles['table-heading']}>
            Listing / Enrollment Events
          </div>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>
          {loading ? <Loading /> : (
            <>
              <Table responsive>
                <thead>
                  <tr>
                    {tableHeaders.map(
                    (header, index) => {
                      return <th className={styles[header['class']]} key={index}>{header.value}</th>
                    }
                    )}
                  </tr>
                </thead>
                <tbody>
                  {pagedData.currentData().map((ts, index) => (
                    <tr key={index}>
                      <td className={styles['vertical-align']}>
                        <div>{ts.issuerDisplayName}</div>
                      </td>
                      <td>
                        {ts.securityList.map((s, i) =>
                          <div key={i}>{s.prefShortName}</div>
                        )}
                      </td>
                      <td>
                        {ts.securityList.map((s, i) =>
                          <div className={styles['align-right']} key={i}>{`${s.currency} ${toCurrency(s.amount)}`}</div>
                        )}
                      </td>
                      <td>
                        {ts.securityList.map((s, i) =>
                          <div key={i}>{s.maturityDate}</div>
                        )}
                      </td>
                      <td className={styles['vertical-align']}>
                        {ts.securityList.map((s, i) =>
                          <div key={i}>{s.listingDate}</div>
                        )}
                      </td>
                      <td className={styles['vertical-align']}>
                        <div>{ts.lastUpdatedDate}</div>
                      </td>
                      <td className={styles['vertical-align']}>
                        {renderStatus(ts.applicationStatus)}
                      </td>
                      <td
                        className={`${styles['vertical-align']} ${styles['detail-arrow']}`}
                        onClick={() => history.push(`/listing/${ts.applicationId}?ic=${ts.institutionCode}`)}
                      >
                        <img alt="See Details" src={detailsArrowIcon} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {
                pagedData.maxPage > 0
                  ? <Pagination>
                    <Pagination.First
                      onClick={() => pagedData.jump(1)}
                      disabled={pagedData.currentPage === 1}>
                      <img alt="FIRST" src={paginationLeftIcon} />
                    </Pagination.First>
                    <Pagination.Prev
                      onClick={() => pagedData.jump(pagedData.currentPage - 1)}
                      disabled={pagedData.currentPage === 1}>
                      PREV
                    </Pagination.Prev>
                    {pages}
                    <Pagination.Next
                      onClick={() => pagedData.jump(pagedData.currentPage + 1)}
                      disabled={pagedData.currentPage === pagedData.maxPage}>
                      NEXT
                    </Pagination.Next>
                    <Pagination.Last
                      onClick={() => pagedData.jump(pagedData.maxPage)}
                      disabled={pagedData.currentPage === pagedData.maxPage}>
                      <img alt="LAST" src={paginationRightIcon} />
                    </Pagination.Last>
                  </Pagination>
                  : <div className={styles['no-data']}>No term sheets to display.</div>
              }
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AdminListingList;